var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.newClass,on:{"click":_vm.sort}},[_c('span',{staticClass:"pointer"},[_vm._m(0),_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"caret-wrapper"},[_c('i',{staticClass:"sort-caret ascending"}),_c('i',{staticClass:"sort-caret descending"})])
}]

export { render, staticRenderFns }